var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencilHand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 60,
    viewBox: "0 0 51 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8353 21.8467C32.1306 22.6785 38.1515 24.903 41 25.9113L38.482 41.0307C38.5363 40.6912 37.9657 40.9955 35.243 44.9107C31.8248 49.8259 26.5175 49.7314 25.618 49.8259C24.7184 49.9205 23.0993 49.0697 20.3107 50.3931C17.5222 51.7164 12.9345 52 11.5852 52C10.2359 52 7.17752 50.7712 7.80719 48.3136C8.31093 46.3474 9.87612 45.5408 10.5957 45.3833C13.7141 44.9737 19.5731 43.3227 18.0619 39.9954C16.5507 36.6681 13.1144 34.9541 11.5852 34.513C10.8356 34.2609 9.1565 33.908 8.43687 34.513C7.71724 35.1179 9.45634 38.231 10.4158 39.7118C10.9556 41.3503 11.4233 44.9296 8.97659 46.1395C5.91817 47.6519 4.56887 46.3285 3.66934 44.9107C2.7698 43.4928 2.94971 39.9009 2.7698 37.8213C2.73372 37.4043 2.64036 36.9112 2.51266 36.387C1.79482 33.4404 0.326469 30.2628 1.81416 27.62C3.16357 25.2228 5.87892 24.3904 7.53734 24.3044C7.32145 21.0527 9.7262 20.4289 10.9556 20.5234C9.96608 17.026 13.3843 16.6479 14.8236 17.215C16.2628 17.7822 17.5222 17.6876 20.6705 18.0657C23.8189 18.4438 29.2161 20.807 30.8353 21.8467Z",
    fill: "#BE7C19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1757 21.0086C9.91912 20.9168 7.4612 21.5224 7.68186 24.6784C6.05645 24.7585 3.43774 25.5046 2.00914 27.6173C0.232902 30.244 1.90405 33.6288 2.62241 36.7173C2.71361 37.1094 2.77968 37.4769 2.80893 37.7979C2.99281 39.8163 2.80893 43.3026 3.72835 44.6788M20.7376 50C23.5878 48.7156 25.2428 49.5413 26.1622 49.4495C27.0816 49.3578 32.5062 49.4495 36 44.6788",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1107 41.4752C36.5205 35.1798 38.3999 29.5946 40.1525 26.2213C40.8812 24.8188 42.4915 24.2097 44.0382 24.5351L47.0919 25.1777C49.2513 25.632 50.6348 27.7493 50.1839 29.9094L47.6391 42.0997C47.1889 44.2562 45.0797 45.6428 42.9214 45.2011L40.0884 44.6212C38.5172 44.2996 37.2604 43.072 37.1107 41.4752Z",
    fill: "#7B7DFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 51.3638L5.47872 59L9.5 52.8538L23 2.19436C22.8723 1.91499 22.3298 1.30037 21.1809 1.07687C20.0319 0.853373 19.1702 1.16999 18.883 1.35624L5 51.3638Z",
    fill: "#F8C96A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15385 59L5 56L7 56.4286L5.15385 59Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 51C6.51925 51.1143 6.27406 52.0476 6.27406 53C6.54431 52 7.27014 50 8.01141 50C8.75268 50 8.78357 51.7143 8.70635 52.5714C8.938 52.381 9.47079 52 9.74877 52",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81818 51.6311C9.6 51.6311 9.18182 51.877 9 52L22.5455 1L23 1.55335L10 52C10.0303 51.877 10.0364 51.6311 9.81818 51.6311Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01852 53C6.01852 52.3844 5.81481 51.1346 5 51.0607L18.4259 1.37841C18.9444 1.00902 19.6914 0.978241 20 1.00902L6.01852 53Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0322 40C18.2128 40.4136 18.2803 40.8012 18.2542 41.1634L20 50.3125C17.3405 51.625 12.9705 52 11.6837 52C10.3968 52 7.4799 50.7812 8.08044 48.3438C8.56087 46.3938 10.0483 45.5 10.7346 45.3438C13.3359 44.9884 18.0721 43.6912 18.2542 41.1634L18.0322 40Z",
    fill: "#BE7C19"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26.0002C9.51515 25.4774 8.03636 24.3726 6 25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencilHand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil-hand.e33d9c270c086f21f5908b9a4e3ac5bf.svg";